"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnunciosPrincipal = void 0;
/*!

=========================================================
* Now UI Dashboard React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
var React = require("react");
// reactstrap components
// import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
var reactstrap_1 = require("reactstrap");
var reactstrap_2 = require("reactstrap");
var classnames_1 = require("classnames");
var url_js_1 = require("../variables/url.js");
var espolAds_js_1 = require("../variables/espolAds.js");
/*const localBack = 'http://localhost:3368/';*/
var localBack = url_js_1.default.localBack;
var enlace = localBack + 'api/Catalog/receptor/';
var enlace2 = localBack + 'api/Catalog/receptor/porvencer/';
var AnunciosPrincipal = /** @class */ (function (_super) {
    __extends(AnunciosPrincipal, _super);
    function AnunciosPrincipal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleKeyPress = function (event) {
            if (event.charCode === 13 && _this.state.buscar !== "") {
                /*console.log('enter press here! ');*/
                //console.log("Buscar", this.state.buscar);
                //console.log("Active", this.state.activeTab);
                _this.cambiarTap(_this.state.buscar, _this.state.activeTab);
            }
        };
        _this.cambiarTap = function (name, num) {
            var trabajo = "";
            if (num === "1") {
                trabajo = enlace;
            }
            if (num === "2") {
                trabajo = enlace2;
            }
            if (name == null) {
                if (!espolAds_js_1.checkCookie('token')) {
                    fetch(trabajo, {
                        method: 'GET',
                    })
                        .then(function (response) {
                        _this.setState({ status: response.status });
                        return response.json();
                    })
                        .then(function (dataP) {
                        _this.setState({ dtoList: dataP });
                        /*console.log(enlace2);*/
                    });
                    //limpiar
                    /*console.log("refresh");*/
                    /*this.setState({ buscar: "" });*/
                    /*document.getElementById("buscar-1").setAttribute("value","");*/
                }
                else {
                    fetch(trabajo, {
                        method: 'GET',
                        headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
                    })
                        .then(function (response) {
                        _this.setState({ status: response.status });
                        return response.json();
                    })
                        .then(function (dataP) {
                        _this.setState({ dtoList: dataP });
                        /*console.log(enlace2);*/
                    });
                    /*console.log("refresh 2");*/
                    _this.setState({ buscar: "", inicio: "", fin: "" });
                }
            }
            if (name != null) {
                if (!espolAds_js_1.checkCookie('token')) {
                    fetch(trabajo + "search" + "/" + name, {
                        method: 'GET',
                    })
                        .then(function (response) {
                        _this.setState({ status: response.status });
                        return response.json();
                    })
                        .then(function (dataP) {
                        _this.setState({ dtoList: dataP });
                        /*console.log(enlace2 + "search" + "/" + name);*/
                    });
                }
                else {
                    fetch(trabajo + "search" + "/" + name, {
                        method: 'GET',
                        headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
                    })
                        .then(function (response) {
                        _this.setState({ status: response.status });
                        return response.json();
                    })
                        .then(function (dataP) {
                        _this.setState({ dtoList: dataP });
                        /*console.log(enlace2 + "search" + "/" + name);*/
                    });
                }
            }
            //console.log(this.state.dtoList);
            //console.log(this.state.buscar);
        };
        _this.filtrofecha = function (inicio, fin, num) {
            var trabajo = "";
            if (num == "1") {
                trabajo = enlace;
            }
            if (num == "2") {
                trabajo = enlace2;
            }
            if (inicio != null && fin != null) {
                if (!espolAds_js_1.checkCookie('token')) {
                    fetch(trabajo + "search-fecha/" + inicio + "/" + fin, {
                        method: 'GET',
                    })
                        .then(function (response) { return response.json(); })
                        .then(function (dataP) {
                        _this.setState({ dtoList: dataP });
                    });
                }
                else {
                    fetch(trabajo + "search-fecha/" + inicio + "/" + fin, {
                        method: 'GET',
                        headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
                    })
                        .then(function (response) { return response.json(); })
                        .then(function (dataP) {
                        _this.setState({ dtoList: dataP });
                    });
                }
            }
            /*console.log("inicio", inicio, "fin", fin);*/
        };
        _this.cambiarPagina = function (page) {
            if (page != null)
                fetch(page, {
                    method: 'GET',
                    headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
                })
                    .then(function (response) {
                    _this.setState({ status: response.status });
                    return response.json();
                })
                    .then(function (dataP) {
                    _this.setState({ dtoList: dataP });
                });
        };
        _this.state = {
            activeTab: '1',
            dtoList: { pageNumber: 0, pageSize: 0, firstPage: "", lastPage: "", totalPages: 0, totalRecords: 0, nextPage: "", previousPage: "", data: [], succeeded: false, errors: "", message: "" },
            loading: true,
            buscar: '',
            inicio: '',
            fin: '',
            status: 0,
            consulta: 'http://localhost:3368/api/Catalog/receptor',
            login: false,
        };
        if (!espolAds_js_1.checkCookie('token')) {
            fetch(enlace, {
                method: 'GET',
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                _this.setState({ dtoList: data, loading: false, login: false });
            });
        }
        else {
            fetch(enlace, {
                method: 'GET',
                headers: { "Authorization": "Bearer " + espolAds_js_1.getCookie('token') },
            })
                .then(function (response) { return response.json(); })
                .then(function (data) {
                _this.setState({ dtoList: data, loading: false, login: true });
            });
        }
        _this.toggle = _this.toggle.bind(_this);
        _this.handleEdit = _this.handleEdit.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.fechaInicio = _this.fechaInicio.bind(_this);
        _this.fechaFin = _this.fechaFin.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        return _this;
        /*console.log(this.state.login)*/
    }
    AnunciosPrincipal.prototype.toggle = function (tab) {
        if (this.state.activeTab !== tab)
            this.setState({ activeTab: tab });
    };
    AnunciosPrincipal.prototype.render = function () {
        var contents = this.state.loading
            ? React.createElement("div", null,
                React.createElement("h5", { className: "title" }, "Loading...."),
                React.createElement("div", { className: "loader" }))
            : this.renderAnuncios(this.state.dtoList);
        return React.createElement("div", null,
            React.createElement("div", { id: "top" }),
            React.createElement(reactstrap_1.Card, null,
                React.createElement(reactstrap_1.CardHeader, null,
                    React.createElement("h5", { className: "title" }, " PRINCIPAL")),
                React.createElement(reactstrap_1.CardBody, null, contents)));
    };
    AnunciosPrincipal.prototype.handleEdit = function (id) {
        this.props.history.push("/ver-anuncio/" + id);
    };
    AnunciosPrincipal.prototype.handleSearch = function (event) {
        this.setState({ buscar: event.target.value });
        /*console.log(this.state.buscar);  */
    };
    AnunciosPrincipal.prototype.refreshInput = function () {
        this.setState({ buscar: "" });
    };
    AnunciosPrincipal.prototype.fechaInicio = function (event) {
        this.setState({ inicio: event.target.value });
        //console.log("inicio",this.state.inicio);
    };
    AnunciosPrincipal.prototype.fechaFin = function (event) {
        this.setState({ fin: event.target.value });
        //console.log("fin",this.state.fin);
    };
    AnunciosPrincipal.prototype.renderAnuncios = function (dtoList) {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Row, null,
                React.createElement(reactstrap_1.Col, { md: 12 },
                    React.createElement(reactstrap_1.Card, null,
                        React.createElement(reactstrap_1.CardBody, { className: "main-content" },
                            React.createElement("div", null,
                                React.createElement(reactstrap_1.Nav, { pills: true },
                                    React.createElement(reactstrap_1.NavItem, null,
                                        React.createElement(reactstrap_1.NavLink, { className: classnames_1.default({ active: this.state.activeTab === '1' }), onClick: function () { _this.toggle('1'); _this.cambiarTap(null, "1"); } }, "Publicaciones recientes")),
                                    React.createElement(reactstrap_1.NavItem, null,
                                        React.createElement(reactstrap_1.NavLink, { className: classnames_1.default({ active: this.state.activeTab === '2' }), onClick: function () { _this.toggle('2'); _this.cambiarTap(null, "2"); } }, "Por Vencer"))),
                                React.createElement(reactstrap_1.TabContent, { activeTab: this.state.activeTab },
                                    React.createElement(reactstrap_1.TabPane, { tabId: "1" },
                                        React.createElement(reactstrap_1.Row, null,
                                            React.createElement("div", { className: "col-md-1" },
                                                React.createElement(reactstrap_2.InputGroup, { className: "" },
                                                    React.createElement(reactstrap_2.InputGroupAddon, null,
                                                        React.createElement(reactstrap_2.InputGroupText, { onClick: function (e) { return _this.cambiarTap(null, "1"); } },
                                                            React.createElement("i", { className: "fas fa-redo" }))))),
                                            React.createElement("div", { className: "col-md-3" },
                                                React.createElement(reactstrap_2.InputGroup, { className: "" },
                                                    React.createElement(reactstrap_2.Input, { id: "buscar-1", placeholder: "Buscar...", onChange: this.handleSearch, onKeyPress: this.handleKeyPress, value: this.state.buscar }),
                                                    React.createElement(reactstrap_2.InputGroupAddon, { addonType: "append" },
                                                        React.createElement(reactstrap_2.InputGroupText, { onClick: function (e) { return _this.cambiarTap(_this.state.buscar, "1"); } },
                                                            React.createElement("i", { className: "now-ui-icons ui-1_zoom-bold" }))))),
                                            React.createElement("div", { className: "col-md-5" },
                                                React.createElement("div", { className: "form-group row", id: "dtblock" },
                                                    React.createElement("div", { className: "col-md-5" },
                                                        React.createElement("input", { className: "form-control", type: "date", id: "dtInicio", name: "dtInicio", onChange: this.fechaInicio, defaultValue: this.state.inicio == null ? null : this.state.inicio.split("T")[0], value: this.state.inicio })),
                                                    React.createElement("div", { className: "col-md-5" },
                                                        React.createElement("input", { className: "form-control", type: "date", id: "dtFin", name: "dtFin", onChange: this.fechaFin, defaultValue: this.state.fin == null ? null : this.state.fin.split("T")[0], value: this.state.fin })),
                                                    React.createElement("div", { className: "col-md-2" },
                                                        React.createElement(reactstrap_2.InputGroup, { className: "" },
                                                            React.createElement(reactstrap_2.InputGroupAddon, null,
                                                                React.createElement(reactstrap_2.InputGroupText, { onClick: function (e) { return _this.filtrofecha(_this.state.inicio, _this.state.fin, "1"); } },
                                                                    React.createElement("i", { className: "far fa-calendar" }))))))),
                                            React.createElement("div", { className: "pagination col-md-3 c-right" },
                                                React.createElement("a", { onClick: function (pag) { return _this.cambiarPagina(dtoList.firstPage); } }, "\u00AB"),
                                                React.createElement("a", { hidden: dtoList.previousPage == null, onClick: function (pag) { return _this.cambiarPagina(dtoList.previousPage); } }, dtoList.previousPage != null ? dtoList.pageNumber - 1 : "-"),
                                                React.createElement("a", { className: "active" }, dtoList.pageNumber),
                                                React.createElement("a", { hidden: dtoList.nextPage == null, onClick: function (pag) { return _this.cambiarPagina(dtoList.nextPage); } }, dtoList.nextPage != null ? dtoList.pageNumber + 1 : "-"),
                                                React.createElement("a", { onClick: function (pag) { return _this.cambiarPagina(dtoList.lastPage); } }, "\u00BB"))),
                                        React.createElement("div", { className: "mb-4" }),
                                        React.createElement(reactstrap_1.Row, null,
                                            dtoList.data.map(function (dto) {
                                                return React.createElement(reactstrap_1.Col, { sm: "3", className: "mb-4" },
                                                    React.createElement(reactstrap_1.Card, { key: dto.idAnuncio, body: true },
                                                        React.createElement("a", { className: "action", onClick: function (id) { return _this.handleEdit(dto.idAnuncio); } },
                                                            React.createElement("img", { src: dto.txImagen, alt: "anuncio", className: "imagen1" })),
                                                        React.createElement(reactstrap_1.CardTitle, null, dto.txTitulo),
                                                        React.createElement(reactstrap_1.CardText, null,
                                                            dto.txTexto != null ? dto.txTexto.length > 50
                                                                ? React.createElement("div", { className: "mb-2" }, dto.txTexto.substring(0, 55) + "...")
                                                                : React.createElement("div", { className: "mb-2" }, "" + dto.txTexto.substring(0, 55))
                                                                : null,
                                                            React.createElement("div", null, dto.bdTipo == 'A' && dto.dtPublicacion != null ? dto.dtPublicacion.split("T")[0] : dto.dtInicio.split("T")[0]))));
                                            }),
                                            dtoList.data.length == 0 ? React.createElement("div", { className: "row col-md-12" },
                                                React.createElement(reactstrap_1.Card, { className: "row col-md-6", body: true },
                                                    React.createElement("a", { className: "action" }),
                                                    React.createElement(reactstrap_1.CardTitle, null),
                                                    React.createElement(reactstrap_1.CardText, null,
                                                        React.createElement("div", null))),
                                                React.createElement(reactstrap_1.Card, { className: "row col-md-6", body: true },
                                                    React.createElement("a", { className: "action" }),
                                                    React.createElement(reactstrap_1.CardTitle, null, "No hay Resultados"),
                                                    React.createElement(reactstrap_1.CardText, null,
                                                        React.createElement("div", null)))) : null))),
                                React.createElement(reactstrap_1.TabContent, { activeTab: this.state.activeTab },
                                    React.createElement(reactstrap_1.TabPane, { tabId: "2" },
                                        React.createElement(reactstrap_1.Row, null,
                                            React.createElement("div", { className: "col-md-1" },
                                                React.createElement(reactstrap_2.InputGroup, { className: "" },
                                                    React.createElement(reactstrap_2.InputGroupAddon, null,
                                                        React.createElement(reactstrap_2.InputGroupText, { onClick: function (e) { return _this.cambiarTap(null, "2"); } },
                                                            React.createElement("i", { className: "fas fa-redo" }))))),
                                            React.createElement("div", { className: "col-md-3" },
                                                React.createElement(reactstrap_2.InputGroup, { className: "" },
                                                    React.createElement(reactstrap_2.Input, { id: "buscar-2", placeholder: "Buscar...", onChange: this.handleSearch, onKeyPress: this.handleKeyPress, value: this.state.buscar }),
                                                    React.createElement(reactstrap_2.InputGroupAddon, { addonType: "append" },
                                                        React.createElement(reactstrap_2.InputGroupText, { onClick: function (e) { return _this.cambiarTap(_this.state.buscar, "2"); } },
                                                            React.createElement("i", { className: "now-ui-icons ui-1_zoom-bold" }))))),
                                            React.createElement("div", { className: "col-md-5" },
                                                React.createElement("div", { className: "form-group row", id: "dtblock" },
                                                    React.createElement("div", { className: "col-md-5" },
                                                        React.createElement("input", { className: "form-control", type: "date", id: "dtInicio", name: "dtInicio", onChange: this.fechaInicio, defaultValue: this.state.inicio == null ? null : this.state.inicio.split("T")[0], value: this.state.inicio })),
                                                    React.createElement("div", { className: "col-md-5" },
                                                        React.createElement("input", { className: "form-control", type: "date", id: "dtFin", name: "dtFin", onChange: this.fechaFin, defaultValue: this.state.fin == null ? null : this.state.fin.split("T")[0], value: this.state.fin })),
                                                    React.createElement("div", { className: "col-md-2" },
                                                        React.createElement(reactstrap_2.InputGroup, { className: "" },
                                                            React.createElement(reactstrap_2.InputGroupAddon, null,
                                                                React.createElement(reactstrap_2.InputGroupText, { onClick: function (e) { return _this.filtrofecha(_this.state.inicio, _this.state.fin, "2"); } },
                                                                    React.createElement("i", { className: "far fa-calendar" }))))))),
                                            React.createElement("div", { className: "pagination col-md-3 c-right" },
                                                React.createElement("a", { onClick: function (pag) { return _this.cambiarPagina(dtoList.firstPage); } }, "\u00AB"),
                                                React.createElement("a", { hidden: dtoList.previousPage == null, onClick: function (pag) { return _this.cambiarPagina(dtoList.previousPage); } }, dtoList.previousPage != null ? dtoList.pageNumber - 1 : "-"),
                                                React.createElement("a", { className: "active" }, dtoList.pageNumber),
                                                React.createElement("a", { hidden: dtoList.nextPage == null, onClick: function (pag) { return _this.cambiarPagina(dtoList.nextPage); } }, dtoList.nextPage != null ? dtoList.pageNumber + 1 : "-"),
                                                React.createElement("a", { onClick: function (pag) { return _this.cambiarPagina(dtoList.lastPage); } }, "\u00BB"))),
                                        React.createElement("div", { className: "mb-4" }),
                                        React.createElement(reactstrap_1.Row, null,
                                            dtoList.data.map(function (dto) {
                                                return React.createElement(reactstrap_1.Col, { sm: "3", className: "mb-4" },
                                                    React.createElement(reactstrap_1.Card, { key: dto.idAnuncio, body: true },
                                                        React.createElement("a", { className: "action", onClick: function (id) { return _this.handleEdit(dto.idAnuncio); } },
                                                            React.createElement("img", { src: dto.txImagen, alt: "anuncio", className: "imagen1" })),
                                                        React.createElement(reactstrap_1.CardTitle, null, dto.txTitulo),
                                                        React.createElement(reactstrap_1.CardText, null,
                                                            dto.txTexto != null ? dto.txTexto.length > 50
                                                                ? React.createElement("div", { className: "mb-2" }, dto.txTexto.substring(0, 55) + "...")
                                                                : React.createElement("div", { className: "mb-2" }, "" + dto.txTexto.substring(0, 55))
                                                                : null,
                                                            React.createElement("div", null, dto.bdTipo == 'A' && dto.dtPublicacion != null ? dto.dtPublicacion.split("T")[0] : dto.dtInicio.split("T")[0]))));
                                            }),
                                            dtoList.data.length == 0 ? React.createElement("div", { className: "row col-md-12" },
                                                React.createElement(reactstrap_1.Card, { className: "row col-md-6", body: true },
                                                    React.createElement("a", { className: "action" }),
                                                    React.createElement(reactstrap_1.CardTitle, null),
                                                    React.createElement(reactstrap_1.CardText, null,
                                                        React.createElement("div", null))),
                                                React.createElement(reactstrap_1.Card, { className: "row col-md-6", body: true },
                                                    React.createElement("a", { className: "action" }),
                                                    React.createElement(reactstrap_1.CardTitle, null, "No hay Resultados"),
                                                    React.createElement(reactstrap_1.CardText, null,
                                                        React.createElement("div", null)))) : null))))))))));
    };
    return AnunciosPrincipal;
}(React.Component));
exports.AnunciosPrincipal = AnunciosPrincipal;
exports.default = AnunciosPrincipal;
//# sourceMappingURL=AnunciosPrincipal.js.map